import type { UiDensity, UiGap } from '../types';

export type UiAlignment = 'start' | 'center' | 'end' | 'stretch';
export type UiJustification = 'start' | 'center' | 'end' | 'between';
export type UiPadding = 'none' | 'xs' | 'sm' | 'md' | 'lg';

export const gapClasses: Record<UiGap, string> = {
    none: 'gap-0',
    xs: 'gap-1',
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
    xl: 'gap-8'
};

export const alignmentClasses: Record<UiAlignment, string> = {
    start: 'items-start',
    center: 'items-center',
    end: 'items-end',
    stretch: 'items-stretch'
};

export const justificationClasses: Record<UiJustification, string> = {
    start: 'justify-start',
    center: 'justify-center',
    end: 'justify-end',
    between: 'justify-between'
};

export const paddingClasses: Record<UiPadding, string> = {
    none: 'p-0',
    xs: 'p-1',
    sm: 'p-2',
    md: 'p-3',
    lg: 'p-5'
};

export const densityGapClasses: Record<UiDensity, string> = {
    compact: 'gap-2',
    comfortable: 'gap-4',
    spacious: 'gap-6'
};
